import _ from 'lodash';
import { ScenarioComparison } from 'types/pricingSimulator';
import { getPercentageChangeV2 } from 'utils/helperMethods';

export const comparisonTableDataParser = (data: any[], scenarioComparisonState: ScenarioComparison) => {
    try {
        const result = data?.map((item: any, index: number) => {
            const scenarioObject: any = {};
            item?.scenarios_data?.map((scenario: any) => {
                const newValue = scenario?.new;
                const oldValue = scenario?.actual;
                const percentageChange = _.isNil(newValue)
                    ? undefined
                    : getPercentageChangeV2(scenario?.actual, newValue);
                const absChange = _.isNil(newValue) ? undefined : newValue - scenario?.actual;

                scenarioObject[` ${scenario?.['scenario_id']}`] = {
                    label: scenario?.['name'],
                    pre: scenarioComparisonState?.selectedKpiItem?.pre || '',
                    post: scenarioComparisonState?.selectedKpiItem?.post || '',
                    key: scenario?.scenario_id, // dont change this
                    sortKey: `kpi_${scenarioComparisonState?.selectedKpiItem?.id}_${scenario?.scenario_id}`,
                    newValue,
                    oldValue,
                    perChange: percentageChange ?? undefined,
                    absChange: absChange ?? undefined,
                };
            });

            //dynamically adding dimensions
            const dimAttributes: any = {};
            item?.attributes_data?.forEach((attributeType: any) => {
                dimAttributes[attributeType['attribute_type']] = attributeType.attribute_name;
            });
            return {
                key: `${item?.attributes_data?.[0]?.attribute_name}-${index}-${item?.attributes_data?.[1]?.attribute_name}`,
                ...dimAttributes,
                attributeNames: Object.values(dimAttributes),
                ...scenarioObject,
            };
        });
        return result;
    } catch (error) {
        throw error;
    }
};
